export default "__VITE_ASSET__CLYK5rcc__"